import { Color } from '@billy/design-system'
import { ReactElement } from 'react'
import { LineProps } from 'recharts'

import { BarLayout } from '../../types/barLayout'

const TOP_LINE_INDEX = 3
const LINE_OPACITY = 0.3
const LINE_STROKE_DASHARRAY = '4 6'

export interface SalesReportCartesianLineProps extends LineProps {
  index: number
  layout: BarLayout
}

export const SalesReportCartesianLine = ({
  index,
  layout,
  x1,
  x2,
  y1,
  y2,
}: SalesReportCartesianLineProps): ReactElement | null => {
  // Do not display on top and bottom of graph
  if (index === 0 || (index > TOP_LINE_INDEX && layout !== 'horizontal')) {
    return null
  }

  return (
    <line
      opacity={LINE_OPACITY}
      stroke={Color.Grey300}
      strokeDasharray={LINE_STROKE_DASHARRAY}
      x1={x1}
      x2={x2}
      y1={y1}
      y2={y2}
    />
  )
}
